module.exports = __webpack_public_path__ + "static/Larnie-Boquiren-5f67205599a1292ba9a43482dfbbb46c.jpg";